import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__inner container--inner" }
const _hoisted_3 = { class: "footer__first" }
const _hoisted_4 = { class: "text--tag" }
const _hoisted_5 = { class: "footer__second" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Home")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/components" }, "Component Library")
], -1)
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.fullName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: `mailto:${_ctx.email}`
          }, _toDisplayString(_ctx.email), 9, _hoisted_8)
        ])
      ])
    ])
  ]))
}